import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyDClMBVyMY6aZYFeRBZTWKTvboqC8y2DRA",
  authDomain: "conecta-a8dac.firebaseapp.com",
  projectId: "conecta-a8dac",
  storageBucket: "conecta-a8dac.firebasestorage.app",
  messagingSenderId: "168638063805",
  appId: "1:168638063805:web:dbfc6953420863660c03d4",
  measurementId: "G-T6KMLFZYLQ"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };
